import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeForm from "./StripeForm";

// Stripe Testing Card
// 4242 4242 4242 4242
//12/34
// 567

// Requires Back-End API Route to work

const PUBLISHABLE_KEY =
  "pk_test_51Lkr57BVbfw6pgl5fgJ7GdT8TPr0KgZJXXaUvKN15o0Vq2n7A0z58AsYMF4Ha7ldra2PO5wn9R9Uv0RzD1fCmRw8007U0pzUIp";

const stripePromise = loadStripe(PUBLISHABLE_KEY);

export default function StripeContainer() {
  return (
    <Elements stripe={stripePromise}>
      <StripeForm />
    </Elements>
  );
}
